module.exports = __webpack_public_path__ + "public/img/down.40c461b7.svg";